export const bvrExclusions = {
  Efficient_Flight: [],
  Optimal_Discretionary_Fuel_Load: [],
  Delayed_Flaps_Approach: [],
  Reduced_Engine_Taxi_In: [
    {
      field_name: "destination",
      values: ["ANU", "GND", "HAV", "SJU", "SVD", "TAB", "UVF"],
    },
  ],
  Reduced_Engine_Taxi_Out: [
    {
      field_name: "vehicle",
      values: ["B787"],
    },
    {
      field_name: "origin",
      values: ["ANU", "GND", "HAV", "SJU", "SVD", "TAB", "UVF"],
    },
  ],
};
